import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import InputBar from '../molecule/SearchElements/InputBar';
import Select from '../molecule/SearchElements/Select';
import ModalButton from '../atomic/Buttons/ModalButton';
import Icon from '@material-ui/core/Icon';

const Container = styled.div`
  background-color: black;
  padding: 10px;
  // margin: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`
const InputBarStyled = styled(InputBar)`
  background-color: grey;
  border-radius: 10px;
  padding: 0 10px;
`
const SelectStyled = styled(Select)`
  
`
const SriversCoachButton = styled.button`
    display: flex;
    margin-right: 20px;
    text-transform: none;
    max-width: 200px;
    max-height: 40px;
    min-width: 30px;
    overflow: hidden;
    white-space: nowrap;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    opacity: 0.5;
    opacity: ${props => (props.showClearButton ? 1.5 : 0.5)};
    color: ${props => (props.showClearButton ? 'rgb(27, 210, 204)' : 'white')};
    border: ${props => (props.showClearButton ? '1px solid #1bd2cc' : '1px solid white')};
    background-color: transparent;
    align-items: center;
    cursor: pointer;
    border-radius: 4px;
    `

const SelectContainer = styled.div`
  display: flex;
  margin-top: 10px;
`
const ClearButton = styled(Button)`
  display: flex;
  margin-right: 20px;
  text-transform: none;
  max-width: 200px;
  max-height: 40px;
  min-width: 30px;
  overflow: hidden;
  white-space: nowrap;
  justify-content: flex-start;
`;

const ClearFilters = (props) => {
  return (
    <ClearButton variant='outlined' color='secondary' disabled={!props.clearAllEnabled} onClick={() => {
      props.setShowClearButton(false);
      props.clearAll();
    }}> 
      Clear
    </ClearButton>
  );
}

const ModalButtonStyled = styled(ModalButton)`
  margin-left: auto;
`;

const SearchBar = ({
  onInputChange,
  onSelectChange,
  onClearAll,
  selects,
  inputValue,
  selectValues,
  clearAllEnabled,
  createModal: CreateModal,
  onCreateSuccess,
  unique,
  ...other
}) => {
  const [showClearButton, setShowClearButton] = useState(false);
  const [digtal, setDigital] = useState([{label: ' Strivers coach', value: 88045}])

  const getSelects = () => {
    const components = selects.map((item, index) => {
      const grouping = item.value.findIndex(v => v.grouping) >= 0 ? true : false;
      return <SelectStyled
        key={`search-select-${index}`}
        text={item.buttonText}
        multiple={item.multiple}
        header={item.label}
        options={item.value}
        value={selectValues[item.type]}
        onChange={(data) => onSelectChange(item.type,data)}
        variant='outlined'
        aggregate={true}
        grouping={grouping}
        type={item.type}
        {...other}
      />;
    });

    const addButton = (
      <>
      <SriversCoachButton onClick={() =>  {
        onSelectChange('trainer', digtal)
        setShowClearButton(true); 
      }}
      showClearButton={showClearButton}
      >Digtal</SriversCoachButton>
      </>
    );
  
    return (
      unique ? 
      <>
        {components}
        {addButton}
      </> : <>{components}</>
    );

  }

  return (
    <Container {...other}>
      <InputBarStyled
        value={inputValue}
        onChange={data => onInputChange(data)}
        onSubmit={data => onInputChange(data)}
      />
      <SelectContainer>
        {getSelects()}
        <ClearFilters
          onInputChange={onInputChange}
          onSelectChange={onSelectChange}
          clearAll={onClearAll}
          clearAllEnabled={clearAllEnabled}
          setShowClearButton={setShowClearButton}
        />
        {CreateModal && (
          <ModalButtonStyled variant='contained' color='secondary' modalComponent={(<CreateModal onSuccess={onCreateSuccess} />)}>
            <Icon>add</Icon> Add
          </ModalButtonStyled>
        )}
      </SelectContainer>
    </Container>
  )
}

SearchBar.propTypes = {
  onInputChange: PropTypes.func,
  onSelectChange: PropTypes.func,
  onClearAll: PropTypes.func,
  selects: PropTypes.array,
  inputValue: PropTypes.string,
  selectValues: PropTypes.object,
  clearAllEnabled: PropTypes.bool,
  endpoing: PropTypes.string,
};

SearchBar.defaultProps = {
  selects: []
};

export default SearchBar;
